import {zodResolver} from "@hookform/resolvers/zod";
import {useGoogleInfo, useOnboardingStatus, useUpdateFeature} from "@mytour/platform";
import type {ICompany, UpdateFeaturePayload} from "@mytour/shared";
import {NoButton, YesButton} from "@mytour/ui/form";
import {SplitterButtons} from "@mytour/ui/layout";
import {useState} from "react";
import {useForm} from "react-hook-form";
import {Trans as Translate} from "react-i18next";
import {Button} from "reactstrap";
import {z} from "zod";
import {ModalContent, ModalContentWrapper} from "../../ModalContent";
import {Step0} from "./components/Step0";
import {Step1} from "./components/Step1";

type Props = {company: ICompany};

const schemaGoogleAgenda = z.object({
  syncAgenda: z.boolean(),
});
type FormGoogleAgenda = z.infer<typeof schemaGoogleAgenda>;

export function AccountFeaturesGoogleAgenda({company}: Props) {
  const [pending, setPending] = useState(false);
  const [step, setStep] = useState<0 | 1>(0);
  const {updateFeature} = useUpdateFeature();
  const {googleInfo} = useGoogleInfo();
  const {setOnboardingStatus} = useOnboardingStatus();

  const hasGoogleCalendar = googleInfo?.userinfo && googleInfo?.hasGoogleCalendar;

  const {synchronizeAgenda} = company.features;

  const form = useForm<FormGoogleAgenda>({
    resolver: zodResolver(schemaGoogleAgenda),
    defaultValues: {syncAgenda: synchronizeAgenda},
  });

  const Link = (props2: any) => <a href={props2.to} {...props2} />;
  return (
    <ModalContentWrapper>
      <ModalContent>
        <h2 style={{marginTop: "8px"}} className="title-custom-style">
          {"Agenda"}
        </h2>
        {step === 0 && <Step0 />}
        {step === 1 && <Step1 />}
      </ModalContent>
      {step === 0 && (
        <SplitterButtons>
          <NoButton
            onClick={() => {
              form.setValue("syncAgenda", false);
              handleSubmit();
            }}
            disabled={pending}
            pending={pending}
          />
          <YesButton
            onClick={() => {
              form.setValue("syncAgenda", true);
              handleSubmit();
            }}
            disabled={pending}
            pending={pending}
          />
        </SplitterButtons>
      )}
      {step === 1 && (
        <SplitterButtons>
          <NoButton onClick={handleAbort} disabled={pending} pending={pending} />
          <Button
            tag={Link}
            color="success"
            to={googleInfo?.url}
            style={{float: "right"}}
            disabled={pending}
          >
            <Translate i18nKey="google.button">Login</Translate>
          </Button>
        </SplitterButtons>
      )}
    </ModalContentWrapper>
  );

  async function handleSubmit() {
    setPending(true);
    try {
      const {syncAgenda} = form.getValues();
      const entity: UpdateFeaturePayload = {
        synchronizeAgenda: syncAgenda,
      };
      await updateFeature(entity);
      if (syncAgenda && !hasGoogleCalendar) {
        setStep(1);
      } else {
        setOnboardingStatus("FEATURES2");
      }
    } finally {
      setPending(false);
    }
  }

  function handleAbort() {
    form.setValue("syncAgenda", false);
    handleSubmit();
  }
}
